import { Download, Mail, Info, GraduationCap, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const ROUTES = ["foundation", "build", "architecture"];
const LABEL = { foundation: "Foundation", build: "Build", architecture: "Architecture & Evidence" };

export const ResultStep = ({ result, onClose }) => (
  <div data-testid="quiz-result-card">
    <div className="flex gap-2">
      {ROUTES.map((r) => (
        <span key={r} className={`rounded-full px-3 py-1 text-[12px] font-semibold ${r === result.route ? "bg-[#0B1B33] text-white" : "bg-slate-100 text-slate-500"}`}>{LABEL[r]}</span>
      ))}
    </div>
    <p className="mt-5 text-[12px] font-semibold uppercase tracking-[0.14em] text-[#0E9384]">Your provisional route: {result.name}</p>
    <motion.h3 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}
      data-testid="result-headline" className="font-display mt-2 text-[26px] font-bold leading-tight tracking-tight text-[#0B1B33] md:text-[30px]">
      {result.headline}
    </motion.h3>
    <div className="mt-4 rounded-xl border border-teal-100 bg-teal-50/60 p-4 text-[15px] text-slate-800">
      <b className="text-[#0B1B33]">Next step: </b>{result.next_step}
    </div>
    {(result.notes || []).map((n) => (
      <p key={n} className="mt-3 flex gap-2 text-[14px] text-slate-700"><Info className="mt-0.5 h-4 w-4 shrink-0 text-blue-600" />{n}</p>
    ))}
    {result.course_name && (
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
        data-testid="result-course-card" className="mt-5 overflow-hidden rounded-2xl bg-[#0B1B33] p-5 text-white">
        <p className="flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-teal-300"><GraduationCap className="h-4 w-4" /> Your suggested starting course</p>
        <div className="mt-2 flex flex-wrap items-baseline justify-between gap-2">
          <h4 data-testid="result-course-name" className="font-display text-[22px] font-bold">{result.course_name}</h4>
          <span className="rounded-full bg-white/10 px-3 py-1 text-[13px] font-semibold">{result.course_fee?.startsWith("₹") ? `Course fee ${result.course_fee}` : result.course_fee}</span>
        </div>
        <p className="mt-2 text-[14px] text-slate-300">{result.course_why}</p>
        <a data-testid="result-course-link" href="#pathway" onClick={onClose} className="mt-3 inline-flex items-center gap-1.5 text-[14px] font-semibold text-teal-300 hover:text-teal-200">
          See it in the 4-step pathway <ArrowRight className="h-4 w-4" />
        </a>
        <p className="mt-2 text-[12px] text-slate-400">A suggestion, not a requirement. You can start at any stage that fits your prerequisites.</p>
      </motion.div>
    )}
    <div className="mt-6 grid gap-3 sm:grid-cols-2">
      <a data-testid="result-download-pdf-btn" href={result.pdf_url} target="_blank" rel="noreferrer"
        className="btn-teal flex items-center justify-center gap-2 rounded-xl py-3.5 text-[15px] font-semibold">
        <Download className="h-4 w-4" /> Download my PDF guide
      </a>
      <button data-testid="result-close-btn" onClick={onClose} className="rounded-xl border border-slate-300 py-3.5 text-[15px] font-semibold text-[#0B1B33] transition-colors hover:bg-slate-50">
        Back to the page
      </button>
    </div>
    <p className="mt-4 flex gap-2 text-[13px] text-slate-600"><Mail className="h-4 w-4 shrink-0" /> We have also emailed the guide to you. This route is provisional and can be corrected after discussion; it is not a hiring prediction.</p>
  </div>
);
